















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency3CreateTransaction from './digital-currency-3-create-transaction.vue'

@Component({
  components: {
    DigitalCurrency3CreateTransaction
  }
})
class DigitalCurrency2SendPaymentButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean
  @Prop({ default: null }) initialTransaction?: any

  showCreateTransactionDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.showCreateTransactionDialog = isVisible
  }
}


export default DigitalCurrency2SendPaymentButton

